/**
 * Product sync's cached artwork reads, refreshed from outside the page.
 *
 * The By colour grid reads the published links (`getVariantArtworkUrls`,
 * stale after 30 s) and the platen file state (`getPlatenFileState`, 60 s).
 * A file saved or published from the Upload Studio changes both, but the
 * grid only refreshes them for its own uploads, so Back to Product sync
 * showed the old artwork until they went stale.
 *
 * `invalidateProductSyncArtworkReads` marks every cached read of both
 * stale (the caller does not know the product's SKUs): a mounted read
 * refetches now, any other on its next mount (Back to Product sync). No read
 * is made while Product sync is not open.
 */

/** The part of `trpc.useUtils()` this needs (kept narrow so tests can stand it in). */
export interface ProductSyncArtworkReadUtils {
  productSync: {
    getVariantArtworkUrls: { invalidate: () => Promise<void> };
    getPlatenFileState: { invalidate: () => Promise<void> };
  };
}

export async function invalidateProductSyncArtworkReads(utils: ProductSyncArtworkReadUtils): Promise<void> {
  await Promise.all([
    utils.productSync.getVariantArtworkUrls.invalidate(),
    utils.productSync.getPlatenFileState.invalidate(),
  ]);
}
